import React from "react";
import { useInvoice } from "../../../hooks/invoice/useInvoice";
import { ModalCharge } from "../../../shared/ModalCharge/ModalCharge";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { img } from "../../../../../../assets/img";
import classes from "../scss/ViewChargeSunbit.module.scss";
import ViewTipsModal from "../../ViewTipsModal/ViewTipsModal";
import { InputLabel } from "../../../../../../shared/InputLabel/InputLabel";
import { InputCurrency } from "../../../../../../shared/InputCurrency/InputCurrency";

const PaymentTipsModal = ({
  isTipsApplying,
  showTipsModal,
  form,
  isLoading,
}) => {
  const { invoice, amountToPay } = useInvoice();
  const { tSales } = useAppTranslation.Sales();
  const { tCommon } = useAppTranslation.Common();

  const { handleSubmit } = form;

  const onClose = () => {
    showTipsModal.update(false);
  };

  return (
    <ModalCharge
      isOpen
      onClose={onClose}
      title={tSales("checkoutInvoice.paymentOptions.sunbit")}
      imageSrc={img.sunbit}
      imageClassName={classes.titleIcon}
      onCharge={handleSubmit}
      isCharging={isLoading}
      isChargeDisabled={isTipsApplying}
      chargeLabel={tCommon("label.apply")}
    >
      <ViewTipsModal amountToPay={amountToPay} />
      <ModalCharge.InputWrap>
        <InputLabel>
          {tSales("checkoutInvoice.formInputLabel.amount")}
        </InputLabel>
        <InputCurrency
          size="medium"
          prefix={invoice?.currencySymbol}
          value={amountToPay}
          placeholder={tSales("checkoutInvoice.formInputPlaceholder.amount")}
          onChange={() => {}}
          isDisabled
        />
      </ModalCharge.InputWrap>
    </ModalCharge>
  );
};

export default PaymentTipsModal;
